import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=2b0759be&scoped=true&"
import script from "./distributionList.vue?vue&type=script&lang=js&"
export * from "./distributionList.vue?vue&type=script&lang=js&"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=2b0759be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0759be",
  null
  
)

export default component.exports